export const extendTargetValues = {
  returns: 'returns',
  exchanges: 'exchanges',
  both: 'both',
}

export const extendTargetOptions = [
  { value: extendTargetValues.returns, label: 'Plazo devoluciones' },
  { value: extendTargetValues.exchanges, label: 'Plazo cambios' },
  { value: extendTargetValues.both, label: 'Plazo devoluciones y cambios' },
]

const extendModeValues = {
  untilDate: 'until_date',
  byDays: 'by_days',
}

export const extendModeOptions = [
  { label: 'Ampliar hasta fecha', value: extendModeValues.untilDate },
  { label: 'Ampliar por X días', value: extendModeValues.byDays },
]
